module.exports = __webpack_public_path__ + "static/media/posterPlainBg.c3ec0fe9.png";